import axios from "axios";

/**
 * A API de comandos responde 404 quando o equipamento não tem comandos cadastrados
 * (e 204 em alguns cenários). Nos dois casos não é falha de carregamento: normalizamos
 * para uma resposta 204 com lista vazia para os consumidores tratarem como "sem dados".
 */
const emptyCommandsResponse = () => ({status: 204, data: {data: []}});

const isNotFound = (error: unknown): boolean => {
    // O status vem em `response.status` e, no axios 1.x, também no topo do erro.
    const {response, status} = (error ?? {}) as {response?: {status?: number}; status?: unknown};
    return response?.status === 404 || Number(status) === 404;
}

export const findAllCommands = async (equipmentId:number) => {
    const apiUrl = 'api/equipment/find-all-tele-commands'
    try {
        const response = await axios.get(`${apiUrl}/${equipmentId}`);
        return response.status === 204 ? emptyCommandsResponse() : response;
    } catch (error) {
        if (isNotFound(error)) {
            return emptyCommandsResponse();
        }
        return error;
    }
}

export const findAllBrokers = async () => {
    const apiUrl = 'api/broker/find-all'
    try {
        return await axios.get(`${apiUrl}`);
    } catch (error) {
        return error;
    }
};
